import React from 'react';
import Slider from 'react-slick';
import VideoSlider from './VideoSlider';
import s from './VideoSlider.scss';

function PrevArrow(propVal) {
  const { className, style, onClick } = propVal;
  return (
    <button
      type="button"
      className={`${className} ${
        propVal.enableBottomArrows ? s.etimes_arrow : ''
      }`}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

function NextArrow(propVal) {
  const { className, style, onClick } = propVal;
  return (
    <button
      type="button"
      className={`${className} ${
        propVal.enableBottomArrows ? s.etimes_arrow : ''
      }`}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

const VideoSliderWrapper = props => {
  const { enableBottomArrows, isPrime, articleIndex } = props;

  const settings = {
    dots: true,
    slidesToShow: 2.5,
    slidesToScroll: 1.5,
    nextArrow: <NextArrow enableBottomArrows={enableBottomArrows} />,
    prevArrow: <PrevArrow enableBottomArrows={enableBottomArrows} />,
    infinite: false,
    arrows: true,
    dotsClass: s.dots,
  };
  return (
    <VideoSlider
      sectionData={{ ...props }}
      isFromSliderWrapper
      Slider={Slider}
      settings={settings}
      autoPlayLeadVideo
      articleIndex={articleIndex}
      isVideoSkipAds={isPrime}
    />
  );
};

export default VideoSliderWrapper;
